// Design tokens for the Renoten landing page (see Landing.dc.html).
export const colors = {
  primary: "#5850EC",
  primaryHover: "#4038C4",
  primaryTint: "#ECEAFC",
  primarySoft: "#F8F7FE",
  ink: "#16161A",
  body: "#4A4B57",
  bodyStrong: "#6B6C79",
  muted: "#8B8D98",
  faint: "#A0A1AC",
  fainter: "#C7C8D1",
  border: "#EAEAEF",
  line: "#EFEFF3",
  surface: "#FFFFFF",
  page: "#FAFAFA",
};

export const mono = "'JetBrains Mono', ui-monospace, SFMono-Regular, monospace";

export const cardShadow = "0 30px 80px rgba(20,20,40,0.09)";

export const sectionPadding = { py: { xs: 8, md: 12 }, px: { xs: 3, md: 6 } };
